module.exports = __webpack_public_path__ + "img/map-marker-white.eca543be.svg";